module.exports = new __parcel__URL__("theme-park.82d60ef5.jpg").toString();